/* tslint:disable:variable-name */
import { MandrillEmailRecipient } from "./mandrillEmailRecipient";
import { MandrillEmailVariable } from "./mandrillEmailVariable";
import { ConfigureService } from "../../configure/configure.service";

export class MandrillEmailTemplate {
    key: string;
    template_name: string;
    template_content = []; // required by mandrill
    message: {
        from_email: string;
        to: Array<MandrillEmailRecipient>;
        global_merge_vars: Array<MandrillEmailVariable>;
        bcc_address?: string;
    };

    constructor(
        templateName: string,
        emailRecipients: Array<MandrillEmailRecipient>,
        dynamic: Array<MandrillEmailVariable> = [],
        private config: ConfigureService
    ) {
        this.key = this.config.params.mandrillKey;
        this.message = {
            from_email: this.config.params.mandrillFromEmail,
            to: emailRecipients,
            global_merge_vars: dynamic,
        };

        if (this.config.params.mandrillBccEmail) {
            this.message.bcc_address = this.config.params.mandrillBccEmail;
        }

        this.template_name = templateName;
    }
}
